import { jsxs, jsx } from 'react/jsx-runtime';
import { createContext, useState, useEffect, useMemo, useContext } from 'react';
import { merge } from 'lodash';
import 'external-svg-loader';
import { THEME_NAME, defaultThemeLight, defaultThemeDark } from './constants/index.js';
import '../../../styles/main.scss.js';
import '../../../../tokens/token-build/css/_variables.css.js';
import '../../../../tokens/token-build/css/_typography.css.js';
import '../../../../tokens/token-build/css/_colors.css.js';
import '../../../../tokens/token-build/css/_semantic-colors-light.css.js';
import '../../../../tokens/token-build/css/_semantic-colors-dark.css.js';
import '../../../assets/nunito/400.css';
import '../../../assets/nunito/700.css';
import '../../../assets/nunito/800.css';
import '../../../assets/poppins/700.css';

if (typeof window !== 'undefined') {
    document.body.dataset.theme = THEME_NAME.LIGHT;
}
const ThemeContext = createContext(null);
const CSSThemeProvider = ({ theme, defaultThemeName = THEME_NAME.LIGHT, children, }) => {
    const [themeName, setCurrentTheme] = useState(defaultThemeName);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        document.body.classList.add('theme-transition');
        document.body.setAttribute('data-theme', defaultThemeName);
        window.setTimeout(() => {
            document.body.classList.remove('theme-transition');
        }, 1000);
    }, [defaultThemeName]);
    const mergedTheme = useMemo(() => themeName === THEME_NAME.LIGHT
        ? merge(defaultThemeLight, theme)
        : merge(defaultThemeDark, theme), [theme, themeName]);
    return (jsxs(ThemeContext.Provider, { value: { THEME: mergedTheme, setCurrentTheme, themeName }, children: [jsx("svg", { "data-src": "https://static.quinyx.com/ui/bundle.svg", "data-unique-ids": "disabled", "data-cache": "disabled", width: 0, height: 0, display: "none" }), children] }));
};
const useCSSTheme = () => {
    const theme = useContext(ThemeContext);
    if (!theme) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return theme;
};
const useToggleTheme = () => {
    const { setCurrentTheme, themeName } = useCSSTheme();
    const toggle = () => setCurrentTheme((prev) => prev === THEME_NAME.LIGHT ? THEME_NAME.DARK : THEME_NAME.LIGHT);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        document.body.classList.add('theme-transition');
        document.body.setAttribute('data-theme', themeName);
        window.setTimeout(() => {
            document.body.classList.remove('theme-transition');
        }, 1000);
    }, [themeName]);
    return toggle;
};

export { CSSThemeProvider, defaultThemeDark, defaultThemeLight, useCSSTheme, useToggleTheme };
